"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonUtils = void 0;
var JsonUtils = /** @class */ (function () {
    function JsonUtils() {
    }
    // Error instances have non-enumerable properties (name, message, stack) and JSON.stringify() only serializes
    // enumerable properties, so we manually extract these and create a new object to serialize.
    JsonUtils.errorToString = function (error) {
        if (error instanceof Error) {
            return JSON.stringify(__assign({ 
                // @ts-ignore
                name: error.name, 
                // @ts-ignore
                message: error.message, stack: error.stack }, error));
        }
        else {
            return JSON.stringify(error);
        }
    };
    return JsonUtils;
}());
exports.JsonUtils = JsonUtils;
//# sourceMappingURL=JsonUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/utils/JsonUtils.js
// module id = 2037
// module chunks = 0